// extracted by mini-css-extract-plugin
export default {"page":"Support_page__UZNzm","content":"Support_content__Je01m"};